import React from 'react';
import Icon from '../../../AppIcon';
import Image from '../../../AppImage';

const RecentSubmissions = ({ submissions }) => {
  if (!submissions || submissions?.length === 0) {
    return (
      <div className="bg-card p-6 text-center">
        <Icon name="FileText" size={48} className="text-muted-foreground mx-auto mb-3" />
        <h3 className="text-lg font-semibold text-foreground mb-2">No Recent Submissions</h3>
        <p className="text-muted-foreground">Your completed scouting reports will appear here.</p>
      </div>
    );
  }

  return (
    <div className="bg-card">
      <div className="p-4 border-b border-border">
        <h3 className="text-lg font-semibold text-foreground">Recent Submissions</h3>
        <p className="text-sm text-muted-foreground">Your latest scouting reports and their status</p>
      </div>
      <div className="divide-y divide-border max-h-96 overflow-y-auto">
        {submissions?.map((submission) => (
          <div key={submission?.id} className="p-4 hover:bg-muted/50 transition-colors duration-200">
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0">
                <Image
                  src={submission?.companyLogo}
                  alt={submission?.companyLogoAlt}
                  className="w-12 h-12 rounded-lg object-cover bg-muted"
                />
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h4 className="text-base font-medium text-foreground truncate">
                    {submission?.companyName}
                  </h4>
                  <div className={`px-2 py-1 rounded-full text-xs font-medium ${
                    submission?.verificationStatus === 'verified' ? 'bg-success/10 text-success' :
                    submission?.verificationStatus === 'pending' ? 'bg-warning/10 text-warning' :
                    submission?.verificationStatus === 'rejected'? 'bg-error/10 text-error' : 'bg-muted text-muted-foreground'
                  }`}>
                    {submission?.verificationStatus}
                  </div>
                </div>
                
                <div className="flex items-center space-x-4 text-sm text-muted-foreground mb-2">
                  <div className="flex items-center space-x-1">
                    <Icon name="Calendar" size={14} />
                    <span>{submission?.submittedDate}</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <Icon name="MapPin" size={14} />
                    <span>{submission?.location}</span>
                  </div>
                </div>
                
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4 text-sm">
                    <div className="flex items-center space-x-1">
                      <Icon name="Star" size={14} className="text-warning" />
                      <span className="text-muted-foreground">Quality Score: {submission?.qualityScore}/100</span>
                    </div>
                    {submission?.hasPhotos && (
                      <div className="flex items-center space-x-1">
                        <Icon name="Camera" size={14} className="text-accent" />
                        <span className="text-muted-foreground">{submission?.photoCount} photos</span>
                      </div>
                    )}
                  </div>
                  
                  {submission?.earnings && (
                    <div className="text-sm font-medium text-success">
                      +${submission?.earnings}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentSubmissions;